import apiClient from './client';

export interface UserListItem {
  id: string;
  email: string;
  full_name: string;
  role: string;
  is_active: boolean;
  deactivated_at: string | null;
  last_login: string | null;
  created_at: string | null;
}

export interface InvitationListItem {
  id: string;
  email: string;
  role: string;
  invited_by_name: string;
  invited_at: string;
  expires_at: string;
  status: 'pending' | 'expired' | 'accepted' | 'revoked';
  accepted_by_user_id: string | null;
}

export interface CreateInvitationPayload {
  email: string;
  role: 'AMM' | 'COMMERCIALE' | 'RT' | 'DIR' | 'OP';
}

export async function listUsers(): Promise<UserListItem[]> {
  const { data } = await apiClient.get<UserListItem[]>('/api/users');
  return data;
}

// Vista minima per il filtro "Operatore" (Scarichi/Produzioni): solo operatori
// attivi (admin/AMM/OP), accessibile anche a AMM/DIR/RT (non solo admin).
export interface OperatoreItem {
  id: string;
  full_name: string;
  role: string;
}

export async function listOperatori(): Promise<OperatoreItem[]> {
  const { data } = await apiClient.get<OperatoreItem[]>('/api/users/operatori');
  return data;
}

export async function listInvitations(): Promise<InvitationListItem[]> {
  const { data } = await apiClient.get<InvitationListItem[]>('/api/users/invitations');
  return data;
}

export async function createInvitation(payload: CreateInvitationPayload): Promise<{ invitation_id: string }> {
  const { data } = await apiClient.post<{ invitation_id: string }>('/api/users/invitations', payload);
  return data;
}

export async function revokeInvitation(id: string): Promise<void> {
  await apiClient.delete(`/api/users/invitations/${id}`);
}

export async function resendInvitation(id: string): Promise<void> {
  await apiClient.post(`/api/users/invitations/${id}/resend`);
}

export async function deactivateUser(id: string): Promise<UserListItem> {
  const { data } = await apiClient.post<UserListItem>(`/api/users/${id}/deactivate`);
  return data;
}

export async function reactivateUser(id: string): Promise<UserListItem> {
  const { data } = await apiClient.post<UserListItem>(`/api/users/${id}/reactivate`);
  return data;
}

// R3-A: cambio ruolo (admin-only lato BE). Ruoli ammessi: i 5 attivi + OP (no OAP/COI legacy).
export type RuoloAssegnabile = 'admin' | 'COMMERCIALE' | 'AMM' | 'DIR' | 'RT' | 'OP';

export async function updateUserRole(id: string, role: RuoloAssegnabile): Promise<UserListItem> {
  const { data } = await apiClient.post<UserListItem>(`/api/users/${id}/role`, { role });
  return data;
}
